<ng-container>
    <app-header fxLayout="column" *ngIf="showHeader"></app-header>
    <div fxLayout="row" fxFlex="100">
        <div class="content" fxLayout="column" fxFlex>
            <app-loader></app-loader>
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-container>
